/**
 * Dark-aware surface tokens for the student portal.
 * Values flip when AdminThemeProvider sets `data-theme="dark"` on <html>.
 */
import { studentPalette } from "./studentPalette";

export const studentSurfaces = {
  canvas: "var(--surface-canvas)",
  raised: "var(--surface-raised)",
  muted: "var(--surface-muted)",
  text: "var(--text-primary)",
  textMuted: "var(--text-muted)",
  border: "var(--border-subtle)",
};

/** Outline buttons on dark cards — filled maroon for readability */
export const studentOutlineButtonDarkSx = {
  "html[data-theme='dark'] &": {
    bg: studentPalette.secondary,
    borderColor: studentPalette.secondary,
    color: studentPalette.cream,
  },
  "html[data-theme='dark'] &:hover": {
    bg: studentPalette.wine,
    borderColor: studentPalette.wine,
    color: studentPalette.cream,
  },
};
